export default [
	// 钓鱼-游戏列表
	{
		name: 'diaoyuList',
		url: '/v1/v6/oic/diaoyuList'
	},
	// 钓鱼游戏-抽奖
	{
		name: 'diaoyu_choujiang',
		url: '/v1/v6/oic/diaoyu_choujiang'
	},
	// 钓鱼-个人抽奖记录-（游戏记录）
	{
		name: 'diaoyu_record_page_geren',
		url: '/v1/v6/oic/diaoyu_record_page_geren'
	},
	// 钓鱼-全服抽奖记录（游戏榜单）
	{
		name: 'diaoyu_record_page_quanfu',
		url: '/v1/v6/oic/diaoyu_record_page_quanfu'
	},
	// 大转盘-列表
	{
		name: 'dazhuanpanList',
		url: '/v1/v6/oic/dazhuanpanList'
	},
	// 大转盘-抽奖
	{
		name: 'dazhuanpan_choujiang',
		url: '/v1/v6/oic/dazhuanpan_choujiang'
	},
	// 大转盘-个人抽奖记录（我的记录）
	{
		name: 'dazhuanpan_record_page_geren',
		url: '/v1/v6/oic/dazhuanpan_record_page_geren'
	},
	// 大转盘-全服抽奖记录
	{
		name: 'dazhuanpan_record_page_quanfu',
		url: '/v1/v6/oic/dazhuanpan_record_page_quanfu'
	},
	// 召唤神龙-列表
	{
		name: 'zhaohuanshenlongList',
		url: '/v1/v6/oic/zhaohuanshenlongList'
	},
	// 召唤神龙-兑换记录-个人
	{
		name: 'zhaohuanshenlong_record_page_geren',
		url: '/v1/v6/oic/zhaohuanshenlong_record_page_geren'
	},
	// 协议详情
	{
		name: 'agreement_details',
		url: '/v1/v6/oic/agreement_details'
	},

	// 扭扭蛋游戏列表
	{
		name: 'niuniudanList',
		url: '/v1/v6/oic/niuniudanList'
	},
	// 扭扭蛋游戏-抽奖
	{
		name: 'niuniudan_choujiang',
		url: '/v1/v6/oic/niuniudan_choujiang'
	},
	// 扭扭蛋-个人抽奖记录-（游戏记录）
	{
		name: 'niuniudan_record_page_geren',
		url: '/v1/v6/oic/niuniudan_record_page_geren'
	},
	// 扭扭蛋-全服抽奖记录（游戏榜单）
	{
		name: 'niuniudan_record_page_quanfu',
		url: '/v1/v6/oic/niuniudan_record_page_quanfu'
	},
	// 猜一猜游戏-奖池列表
	{
		name: 'caiyicaiGiftList',
		url: '/v1/v6/oic/caiyicaiGiftList',
		loading: false, //提示加载中
	},
	// 猜一猜游戏-参与
	{
		name: 'caiyicai_choujiang',
		url: '/v1/v6/oic/caiyicai_choujiang'
	},
	// 猜一猜游戏-我的记录
	{
		name: 'caiyicai_record_page_geren',
		url: '/v1/v6/oic/caiyicai_record_page_geren'
	},
	// 猜一猜游戏-开奖记录
	{
		name: 'caiyicai_record_page_kaijaing',
		url: '/v1/v6/oic/caiyicai_record_page_kaijaing'
	},
	// 猜一猜游戏-获取本场次已经猜的奖品
	{
		name: 'caiyicai_cailist',
		url: '/v1/v6/oic/caiyicai_cailist'
	},
	// 猜一猜-获取是否中奖
	{
		name: 'caiyicai_getresult',
		url: '/v1/v6/oic/caiyicai_getresult',
		loading: false, //提示加载中
	},
	// 猜一猜-重复上轮
	{
		name: 'caiyicai_chongfushanglun',
		url: '/v1/v6/oic/caiyicai_chongfushanglun'
	}
]
